import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  /**
   * The one line explaining that attaching is automatic, so the missing property picker reads as
   * intent rather than an omission. Tinted like every other info block in the app (see `infoBlock`
   * in PropertyUtilitiesSetupPageV2) — on `shades[100]` it sat white-on-white against the modal and
   * read as no banner at all. Aligned to the top rather than centred because this one wraps.
   */
  notice: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    padding: '12px 16px',
    marginBottom: 20,
    borderRadius: 2,
    backgroundColor: palette.info.light,
    '& .MuiTypography-root': {
      color: palette.info.dark
    }
  },
  noteField: {
    marginBottom: 16
  },
  dropzone: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    width: '100%',
    padding: '32px 16px',
    border: "1px dashed ".concat(palette.shades[400]),
    borderRadius: 4,
    backgroundColor: palette.common.white,
    cursor: 'pointer',
    font: 'inherit',
    textAlign: 'center'
  },
  dropzoneActive: {
    borderColor: palette.primary.main,
    backgroundColor: palette.shades[100]
  },
  dropzoneTitle: {
    marginTop: 8,
    color: palette.shades[900]
  },
  dropzoneBrowse: {
    color: palette.primary.main,
    textDecoration: 'underline'
  },
  dropzoneHint: {
    color: palette.shades[700]
  },
  hiddenInput: {
    display: 'none'
  },
  queueLabel: {
    marginTop: 24,
    marginBottom: 8,
    color: palette.shades[700],
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    fontSize: 12
  },
  fileList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    maxHeight: 320,
    overflowY: 'auto',
    scrollbarGutter: 'stable'
  },
  fileRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '10px 12px',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: 2,
    backgroundColor: palette.common.white
  },
  fileMain: {
    flex: 1,
    minWidth: 0
  },
  fileName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: 600,
    color: palette.shades[900]
  },
  fileDetail: {
    color: palette.shades[700]
  },
  fileProgress: {
    margin: '6px 0 4px',
    height: 4,
    borderRadius: 2
  },
  /**
   * Fixed width so a row keeps its shape as a file moves from uploading to extracting to processed,
   * and the list does not shuffle sideways under the reader while a batch settles.
   */
  statusChip: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    flex: '0 0 auto',
    minWidth: 116,
    padding: '4px 10px',
    borderRadius: 4,
    fontSize: 12,
    lineHeight: '18px',
    whiteSpace: 'nowrap'
  },
  /**
   * Colour comes from the tone rule below rather than `currentColor`: the dot carries the state at a
   * glance and wants the saturated shade, while the label beside it stays on the darker one to keep
   * its contrast against the tinted background.
   */
  statusDot: {
    width: 6,
    height: 6,
    borderRadius: '50%'
  },
  chip_info: {
    backgroundColor: palette.info.light,
    color: palette.info.dark,
    '& $statusDot': {
      backgroundColor: palette.info.main
    }
  },
  chip_success: {
    backgroundColor: palette.success.light,
    color: palette.success.dark,
    '& $statusDot': {
      backgroundColor: palette.success.main
    }
  },
  chip_warning: {
    backgroundColor: palette.warning.light,
    color: palette.warning.dark,
    '& $statusDot': {
      backgroundColor: palette.warning.main
    }
  },
  chip_error: {
    backgroundColor: palette.error.light,
    color: palette.error.dark,
    '& $statusDot': {
      backgroundColor: palette.error.main
    }
  },
  backgroundHint: {
    marginTop: 20,
    color: palette.shades[700]
  }
});
export default useStyles;